import { withPrefix } from 'gatsby';
import { useEffect } from 'react';

import { searchConfig } from '../config/searchConfig';

const SearchResultsRedirect = () => {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const { search } = window.location;
        window.location.replace(
            `${withPrefix(searchConfig.resultsRoute)}${search}`
        );
    }, []);

    return null;
};

export default SearchResultsRedirect;
